// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file accounts/accounts_cogs.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { CogsItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.AccountsCogsRequest
 */
export class AccountsCogsRequest extends Message<AccountsCogsRequest> {
  /**
   * Start date for the report
   *
   * @generated from field: int32 start_date = 1;
   */
  startDate = 0;

  /**
   * End date for the report
   *
   * @generated from field: int32 end_date = 2;
   */
  endDate = 0;

  /**
   * Whether to calculate moving average
   *
   * @generated from field: bool calculate_moving_average = 3;
   */
  calculateMovingAverage = false;

  /**
   * Period for moving average calculation
   *
   * @generated from field: int32 moving_average_period = 4;
   */
  movingAveragePeriod = 0;

  constructor(data?: PartialMessage<AccountsCogsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.AccountsCogsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "end_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "calculate_moving_average", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "moving_average_period", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AccountsCogsRequest {
    return new AccountsCogsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AccountsCogsRequest {
    return new AccountsCogsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AccountsCogsRequest {
    return new AccountsCogsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AccountsCogsRequest | PlainMessage<AccountsCogsRequest> | undefined, b: AccountsCogsRequest | PlainMessage<AccountsCogsRequest> | undefined): boolean {
    return proto3.util.equals(AccountsCogsRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.AccountsCogsResponse
 */
export class AccountsCogsResponse extends Message<AccountsCogsResponse> {
  /**
   * List of COGS items
   *
   * @generated from field: repeated com.neulink.pharmacy.CogsItem cogs_items = 1;
   */
  cogsItems: CogsItem[] = [];

  constructor(data?: PartialMessage<AccountsCogsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.AccountsCogsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "cogs_items", kind: "message", T: CogsItem, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AccountsCogsResponse {
    return new AccountsCogsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AccountsCogsResponse {
    return new AccountsCogsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AccountsCogsResponse {
    return new AccountsCogsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AccountsCogsResponse | PlainMessage<AccountsCogsResponse> | undefined, b: AccountsCogsResponse | PlainMessage<AccountsCogsResponse> | undefined): boolean {
    return proto3.util.equals(AccountsCogsResponse, a, b);
  }
}

